import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/css/main.css';

import Header from './Header/Header';
import HeroImageCarousel from './HeroCarousel';
import { Link } from 'react-router-dom';

import mcglogo from '../assets/img/mcg_logo_with_slogan_-removebg-preview.png'

function IndexPage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="index-page">
      <Header />
      <main className="main">
        <section id="hero" className="hero section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row align-items-center">

              <div className="col-lg-6">
                <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
                  <div className="company-badge mb-4">
                    <i className="bi bi-gear-fill me-2"></i>
                    Empowering Your Career Growth
                  </div>

                  <h1 className="mb-4">
                    Build Your <br />
                    Dream Career with <br />
                    <span className="accent-text">MyCareerGems</span>
                  </h1>

                  <p style={{ textAlign: 'justify' }} className="mb-4 mb-md-5">
                    Discover your potential with personalized career counseling, job preparation
                    resources, and expert advice to help you land your dream job. Whether you're a
                    student, graduate, or professional, we've got you covered!
                  </p>

                  <div className="hero-buttons">
                    <Link to="/contact" className="btn btn-primary me-0 me-sm-2 mx-1">Get Started</Link>
                    <a href="#" className="btn btn-link mt-2 mt-sm-0 glightbox">
                      <i className="bi bi-play-circle me-1"></i>
                      Watch Intro Video
                    </a>
                  </div>

                </div>
              </div>

              <div className="col-lg-6">
                <div className="hero-image-container" data-aos="zoom-out" data-aos-delay="300">
                  <div className="hero-image">
                    <img
                      src={mcglogo}
                      width={450}
                      height={450}
                      alt="Career Guidance"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>

              {/* <HeroImageCarousel /> */}

            </div>

            <div className="row stats-row gy-4 mt-5" data-aos="fade-up" data-aos-delay="500">
              <div className="col-lg-3 col-md-6">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="bi bi-trophy"></i>
                  </div>
                  <div className="stat-content">
                    <h4>3x Career Wins</h4>
                    <p className="mb-0">Guiding to success</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="bi bi-briefcase"></i>
                  </div>
                  <div className="stat-content">
                    <h4>6.5k Careers Built</h4>
                    <p className="mb-0">Path to growth</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="bi bi-graph-up"></i>
                  </div>
                  <div className="stat-content">
                    <h4>80k Sessions Held</h4>
                    <p className="mb-0">Empowering futures</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="bi bi-award"></i>
                  </div>
                  <div className="stat-content">
                    <h4>6x Recognized</h4>
                    <p className="mb-0">Top career guides</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
}

export default IndexPage;
